module.exports = new __parcel__URL__("svi-socioeconomic--dataset-cover.b495c268.png").toString();